import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function RewindForwardIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M10.937 4.775 8.395 6.467l.018-1.051a.5.5 0 0 0-.54-.508 4.37 4.37 0 0 0-2.528 1.068 4.26 4.26 0 0 0-1.368 2.357 4.22 4.22 0 0 0 .347 2.697c.359.732.92 1.345 1.614 1.772a.1.1 0 0 1 .026.026q.003.003.003.005l-.007.383a4.66 4.66 0 0 1-1.807-1.687 4.55 4.55 0 0 1-.623-3.052A4.6 4.6 0 0 1 5.024 5.73 4.74 4.74 0 0 1 7.96 4.544a.5.5 0 0 0 .477-.491l.019-1.084z" /></svg>
  );
}

export default RewindForwardIcon;
